import * as Enumerable from "linq";

export class HtmlHelper {

    public static syntaxHighlight(sub: string, full: string) {
        sub = sub ? sub.trim() : sub;
        const initial = full;
        if (sub && full) {
            const split = sub.split(" ");
            let additionalIndex = 0;
            let subWords = split.length > 0 ? split : [sub];
            const initialSubWords = initial.toLowerCase().split(" ");
            subWords = Enumerable.from(subWords).orderBy(() => {
                const index = initialSubWords.findIndex(x => x.indexOf(x.toLowerCase()) > -1);
                if (index > -1) {
                    initialSubWords.splice(index, 1)
                }
                return index;
            }).toArray();

            let lastStart = 0;
            for (const subWord of subWords) {
                let start = initial.toLowerCase().indexOf(subWord.toLowerCase(), lastStart);

                if (start >= 0) {
                    lastStart = start + subWord.length;
                    start = start + additionalIndex;
                    const end = start + subWord.length;
                    full = full.substr(0, start) +
                        '<b>' +
                        full.substr(start, end - start) +
                        '</b>' +
                        full.substr(end);
                    additionalIndex += 7; // 7 html characters
                }
            }
        }
        return full;
    }
}
